import React, { useEffect, useState } from 'react'
import Collapse from '@mui/material/Collapse'
import ListItemText from '@mui/material/ListItemText'
import BubbleChartOutlined from '@mui/icons-material/BubbleChartOutlined'
import IconExpandLess from '@mui/icons-material/ExpandLess'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import WebAssetOutlinedIcon from '@mui/icons-material/WebAssetOutlined'
import WebOutlined from '@mui/icons-material/WebOutlined'
import { useTranslation } from 'react-i18next'
import { Box } from '@mui/material'

import ListItemIcon from 'components/Sidebar/Styled/ListItemIcon'
import ListItemButton from 'components/Sidebar/Styled/Button'
interface SubMenuProps {
  keyItem: string
  name: string
  children: any
  dataTestId?: string
  isDrawerVisible: boolean
  handleDropdownCollapse: () => void
  listItemStyle?: any
}

const SubMenu = ({
  isDrawerVisible,
  handleDropdownCollapse,
  dataTestId,
  keyItem,
  name,
  children,
  listItemStyle,
}: SubMenuProps) => {
  const [isMenuVisible, setMenuVisibility] = useState(false)
  const { t } = useTranslation()

  // Collapse the submenu when the sidebar is collapsed
  useEffect(() => {
    if (!isDrawerVisible) {
      setMenuVisibility(false)
    }
  }, [isDrawerVisible])

  const handleMenuClick = (e: React.MouseEvent<HTMLElement>) => {
    if (!isDrawerVisible) {
      handleDropdownCollapse()
    }

    setMenuVisibility(!isMenuVisible)
    e.stopPropagation()
  }

  const getIcon = (key: string) => {
    switch (key) {
      case 'project':
        return <WebOutlined />
      case 'report':
        return <BubbleChartOutlined />
      case 'site-management':
        return <WebAssetOutlinedIcon />
    }
  }

  return (
    <>
      <ListItemButton
        key={keyItem}
        onClick={handleMenuClick}
        data-testid={dataTestId}
        sx={listItemStyle}
      >
        {keyItem !== 'toolReport' && (
          <ListItemIcon>{getIcon(keyItem)}</ListItemIcon>
        )}
        <ListItemText primary={<Box>{t(`sidebar.${name}`)}</Box>} />
        {isMenuVisible ? <IconExpandLess /> : <ExpandMoreIcon />}
      </ListItemButton>
      <Collapse in={isMenuVisible} timeout="auto" unmountOnExit>
        {children}
      </Collapse>
    </>
  )
}

export default SubMenu
